import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { DepartmentComponent } from './department/department.component';
import { SubDepartmentComponent } from './sub-department/sub-department.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgZorroModule } from 'src/app/ng-zorro.module';
import { FormsModule } from '@angular/forms';
import { CompanyComponent } from './company/company.component';
import { ViewValidationsComponent } from './view-validations/view-validations.component';
import { DepartmentApproversComponent } from './department-approvers/department-approvers.component';
import { HolidayComponent } from './holiday/holiday.component';
import { ManageUserComponent } from './manage-user/manage-user.component';
import { AddUserComponent } from './add-user/add-user.component';


@NgModule({
  declarations: [
    DepartmentComponent,
    SubDepartmentComponent,
    CompanyComponent,
    ViewValidationsComponent,    
    DepartmentApproversComponent, HolidayComponent, ManageUserComponent, AddUserComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AdminRoutingModule,
    SharedModule,
    NgZorroModule
  ]
})
export class AdminModule { }
